import hrCausalMdl from '@/models/HumanResource/HRCausal'

export default async () => {
    try {
        //
        const response = await hrCausalMdl
            .params({ get_all_results: true })
            .get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}
